import classNames from "classnames";
import AscAvatar from "../AscAvatar/AscAvatar";
import styles from "./AscAvatarUploader.module.scss";
import AscFilesUploader, {
  AscFilesUploaderRef,
} from "../AscFilesUploader/AscFilesUploader";
import { useEffect, useRef, useState } from "react";
import AscButton from "../AscButton/AscButton";

export interface AscAvatarUploaderProps {
  className?: string;
  loading?: boolean;
  initialPreview?: string;
  onChange?: (avatar: File) => void;
}

export default function AscAvatarUploader({
  className,
  loading,
  initialPreview,
  onChange,
}: AscAvatarUploaderProps) {
  const [preview, setPreview] = useState<string>();
  const uploaderRef = useRef<AscFilesUploaderRef>(null);

  function handleAvatarChange(files: File[]) {
    if (!files?.length) {
      return;
    }
    if (files.length > 1) {
      uploaderRef.current?.handleRemoveFile(0);
      return;
    }

    onChange?.(files[0]);
    const reader = new FileReader();
    reader.readAsDataURL(files?.[0]);
    reader.onload = function (e: ProgressEvent<FileReader>) {
      setPreview(e?.target?.result as string);
    };
  }

  useEffect(() => {
    if (initialPreview) setPreview(initialPreview);
  }, [initialPreview]);

  return (
    <div
      data-testid="asc-avatar-uploader"
      className={classNames(styles.ground, className)}
    >
      <AscAvatar className={styles.avatar} src={preview} />
      <AscButton
        size={"large"}
        fullWidth
        narrowPadding
        loading={loading}
      >
        Change a photo
      </AscButton>
      <AscFilesUploader
        ref={uploaderRef}
        className={styles.uploadArea}
        classNameFileList={styles.dropZone}
        compact
        disabled={loading}
        accept={{
          "image/*": [".jpeg", ".png"],
        }}
        dropZoneProps={{
          maxFiles: 1,
        }}
        onDrop={handleAvatarChange}
      />
    </div>
  );
}
